import { render } from "./ChallengeRewards.vue?vue&type=template&id=78da69a6"
import script from "./ChallengeRewards.vue?vue&type=script&lang=js"
export * from "./ChallengeRewards.vue?vue&type=script&lang=js"
script.render = render

export default script